import type { Person2 } from "@/app/peopleQueries";
import { Button } from "@/ui/Button";
import { SELECT_CLS } from "./shared";
import { bulkLabel } from "./model";

/** Панель выбора: «выбрано N человек · назначить ментора: [ментор…] / снять».
 *  Применяется только к студентам среди выбранных — и об этом написано рядом. */
export function BulkBar({ selected, mentors, onAssign, onClear, busy }: { selected: Person2[]; mentors: Person2[]; onAssign: (mentorId: string | undefined) => void; onClear: () => void; busy?: boolean }) {
  if (selected.length === 0) return null;
  const { title, hint } = bulkLabel(selected);
  const students = selected.filter((p) => p.role === "student").length;
  const none = students === 0;
  return (
    <div className="mx-5 my-3 flex flex-wrap items-center gap-3 rounded-md border border-acc bg-accsoft px-3.5 py-[11px]" data-testid="bulk-bar" role="region" aria-label="действия с выбранными">
      <span className="font-mono text-[12px] text-acc" data-testid="bulk-count">
        {title}
      </span>
      <span className="font-mono text-[11.5px] text-ink2">· назначить ментора:</span>
      <select
        aria-label="назначить ментора выбранным"
        data-testid="bulk-mentor"
        value=""
        disabled={none || busy}
        onChange={(e) => e.target.value && onAssign(e.target.value)}
        className={SELECT_CLS}
      >
        <option value="">ментор…</option>
        {mentors.map((m) => (
          <option key={m.id} value={m.id}>
            {m.name}
          </option>
        ))}
      </select>
      <Button size="sm" variant="secondary" data-testid="bulk-unassign" disabled={none || busy} onClick={() => onAssign(undefined)}>
        снять
      </Button>
      {hint && (
        <span className="font-mono text-[11px] text-ink2" data-testid="bulk-hint">
          {hint}
        </span>
      )}
      <span className="flex-1" />
      <Button size="sm" variant="ghost" onClick={onClear}>
        снять выбор
      </Button>
    </div>
  );
}
